import { ApiPostRequest } from 'src/app/model/api/api-request/api-post-request';
import { SimpleCompetitor } from '../../../+shared/model/interfaces/simple-competitor';

export class CompetitionSignUpRequest extends ApiPostRequest
{
    public constructor(
        competitor: SimpleCompetitor,
        webapiBasepath: string
    )
    {
        super(  'competition', 
                null, 
                null, 
                { 
                    'competitor': competitor 
                },
                webapiBasepath
            );
    }
}

